import { render, staticRenderFns } from "./procedures.vue?vue&type=template&id=75b37c76&scoped=true&"
import script from "./procedures.vue?vue&type=script&lang=js&"
export * from "./procedures.vue?vue&type=script&lang=js&"
import style0 from "./procedures.vue?vue&type=style&index=0&id=75b37c76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b37c76",
  null
  
)

export default component.exports